import styles from './QuoteHeader.module.css'
import {SaveDto} from "../../api";
import React, {useContext} from "react";
import {ConfiguratorContext} from "../../context";
import {useQuoteContext} from "../../contexts/QuoteContext";
import {Space} from "antd";
import Paragraph from "antd/lib/typography/Paragraph";
import {Link} from "react-router-dom";
import Utils from "../../util/util";
import QuoteNameInput from "./QuoteNameInput";
import QuoteTruckImage from "./QuoteTruckImage";

export const QuoteHeader = (props:{
    hidePricing?: boolean
    onQuoteChanged?: (q:SaveDto | undefined) => void
}) => {

    const configurator = useContext(ConfiguratorContext);

    const quoteContext = useQuoteContext();
    const quote = quoteContext.quote;

    const quoteState = Utils.getQuoteState(configurator, quote);
    const {
        isReadOnly
    } = quoteState;

    const handleUpdateName = (name: string | undefined) => {
        if ( !name?.trim().length ) return;

        props.onQuoteChanged?.({
            name: name
        })
    }

    const boldStyle = {
        fontWeight: "600",
        fontSize: "16px",
        lineHeight: "1.5",
    }

    const isAdmin = configurator.isAdmin();
    const isSalesDesk = configurator.isSalesDesk();
    const isEngineering = configurator.isEngineering();

    return <div style={{display: "flex", width: "100%", gap: "1rem"}} >
        <div style={{flex: "0 1 0" }} >
            <QuoteTruckImage />
        </div>
        <div style={{flex: "1 1 0", minWidth: "15rem", display: "flex", flexDirection: "column", gap: "0.2rem"  }} >
            <div>
                <QuoteNameInput quote={quote}
                                readOnly={isReadOnly && !(isAdmin || isSalesDesk || isEngineering)}
                                txtStyle={{
                                    marginBottom: ".3rem",
                                    color: "rgba(0, 0, 0, 0.88)",
                                    fontWeight: "600",
                                    fontSize: "20px",
                                    lineHeight: "1.4",
                                }}
                                btnStyle={{
                                    whiteSpace: "break-spaces",
                                    height: "auto",
                                    textAlign: "left",
                                }}
                                onChange={handleUpdateName} />
            </div>
            <div style={{display: "flex", width: "100%", gap: "1rem"}}>
                <Space>
                    <div style={boldStyle}>
                        ( {configurator.isInternalSales()
                        ? <Link to={"/configurator/" + encodeURI(quote?.quoteId || "")} target="_blank"><span data-testId={"quoteIdStr"}>{quote?.quoteId}</span></Link>
                        : <span data-testId={"quoteIdStr"}>{quote?.quoteId}</span>} )
                    </div>
                    <Paragraph copyable={{ text: quote?.quoteId }} style={{margin: 0}} />
                </Space>

                <Space>
                    <div><span style={boldStyle}>rev.</span> {quote?.revision}</div>
                    {(configurator.isEngineering() && (!!quote?.epicorRevision?.length && quote?.epicorRevision !== "-") ) &&
                    <div>( <span >Epicor</span> {quote?.epicorRevision} ) </div>}
                </Space>

            </div>

            <Space>
                {quote?.truckDescription}
                <Paragraph copyable={{ text: quote?.truckDescription }} style={{margin: 0}} />
            </Space>

            <div>
                <div className='ellipsis' style={{maxWidth: "100%"}}><span className={styles.label} >Status:</span>{Utils.formatQuoteDisplayStatus(quote, 'horizontal')}</div>
            </div>
        </div>
    </div>

}

export default QuoteHeader;
